import { Outlet } from "react-router";
import { SettingsStrategyProvider } from "src/context/Settings/CsrStrategy/provider";

export const StrategySettingsContext = () => (
    <SettingsStrategyProvider>
        <Outlet />
    </SettingsStrategyProvider>
);
